<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">SVIP套餐管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>性别：</label>
          <el-select v-model="sex" placeholder="Select" style="width: 8em">
            <el-option v-for="item in sexArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 8em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>类型：</label>
          <el-select v-model="payType" placeholder="Select" style="width: 8em">
            <el-option v-for="item in payTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>平台：</label>
          <el-select v-model="platformType" placeholder="Select" style="width: 8em">
            <el-option v-for="item in platformTypeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>版本：</label>
          <el-select v-model="versionState" placeholder="Select" style="width: 8em">
            <el-option v-for="item in versionStateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>支付方式：</label>
          <el-select v-model="payMode" placeholder="Select" style="width: 10em">
            <el-option v-for="item in payModeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>展示包类型：</label>
          <el-select v-model="isSpecialPackage" placeholder="Select" style="width: 10em">
            <el-option v-for="item in isSpecialPackageArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>新人状态：</label>
          <el-select v-model="newuserShow" placeholder="Select" style="width: 8em">
            <el-option v-for="item in newuserShowArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>SVIP状态：</label>
          <el-select v-model="svipShow" placeholder="Select" style="width: 8em">
            <el-option v-for="item in svipShowArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
<!--        <div class="content-input-item">-->
<!--          <label>渠道：</label>-->
<!--          <el-select v-model="channel" placeholder="Select" style="width: 8em">-->
<!--            <el-option v-for="item in channelArray" :key="item.value" :label="item.label" :value="item.value">-->
<!--            </el-option>-->
<!--          </el-select>-->
<!--        </div>-->
        <div class="content-input-item">
          <label>可见用户类型：</label>
          <el-select v-model="isFocusUser" placeholder="Select" style="width: 10em">
            <el-option v-for="item in isFocusUserArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editSetsDialog(-1)">添加</el-button>
<!--          <el-button type="warning" @click="sendMarriageSms()">发送消息</el-button>-->
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            border
        >
          <el-table-column property="createTime" label="时间" v-if="checkColList.indexOf('时间') > -1" />
          <el-table-column property="channel" label="详细信息" v-if="checkColList.indexOf('详细信息') > -1"  width="180">
            <template #default="scope">
              <p>性别： {{scope.row.sex == 1?'男':scope.row.sex == 2?'女':scope.row.sex == 0?'全部':''}}</p>
              <p>渠道：{{scope.row.channel}}</p>
              <p>product_id：{{scope.row.productId}}</p>
              <p>平台：{{ scope.row.platformType == 1?'Android':scope.row.platformType ==2?'ios':scope.row.platformType ===4?'鸿蒙':'' }}</p>
              <p>版本：{{ scope.row.versionState ==1?'旧版（星级特权）':scope.row.versionState ==2?'4.2版本及以上':scope.row.versionState ==3?'4.5版本及以上':'' }}</p>
              <p>类型：{{ scope.row.payType ==1?'普通':scope.row.payType ==2?'自动续费': '' }}</p>
              <p>展示包类型：{{ scope.row.isSpecialPackage ==0?'全部包':scope.row.isSpecialPackage ==2?'非特定包':scope.row.isSpecialPackage ==1?'特定包': '' }}</p>
            </template>
          </el-table-column>
<!--          <el-table-column property="productId" label="苹果ID" v-if="checkColList.indexOf('苹果ID') > -1" />-->
          <el-table-column property="name" label="商品名称" v-if="checkColList.indexOf('商品名称') > -1"></el-table-column>
          <el-table-column property="billName" label="账单名称" v-if="checkColList.indexOf('账单名称') > -1"></el-table-column>
          <el-table-column property="" label="会员类型" v-if="checkColList.indexOf('会员类型') > -1">
            <template #default="scope">
              {{scope.row.type == 1?'限时会员':scope.row.type == 2?'终身会员':''}}
            </template>
          </el-table-column>
          <el-table-column property="" label="支付方式" v-if="checkColList.indexOf('支付方式') > -1">
            <template #default="scope">
              {{scope.row.payMode == 1?'支付宝':scope.row.payMode == 2?'微信':''}}
            </template>
          </el-table-column>
          <el-table-column property="oldPrice" label="原价格" v-if="checkColList.indexOf('原价格') > -1"></el-table-column>
<!--          <el-table-column property="matcherNum" label="牵线次数" v-if="checkColList.indexOf('牵线次数') > -1"></el-table-column>-->
          <el-table-column property="tag" label="标签内容" v-if="checkColList.indexOf('标签内容') > -1"></el-table-column>
          <el-table-column property="price" label="支付价格" v-if="checkColList.indexOf('支付价格') > -1"></el-table-column>
          <el-table-column property="expireTime" label="SVIP时长" v-if="checkColList.indexOf('SVIP时长') > -1">
            <template #default="scope">
              {{scope.row.expireTime/(24*3600)}}
            </template>
          </el-table-column>
          <el-table-column property="freeDay" label="免费试用天数" v-if="checkColList.indexOf('免费试用天数') > -1"></el-table-column>
          <el-table-column property="orderNum" label="排序" v-if="checkColList.indexOf('排序') > -1"></el-table-column>
          <el-table-column property="" label="状态" v-if="checkColList.indexOf('状态') > -1"  width="130">
            <template #default="scope">
              {{scope.row.state == 0?'待上架':scope.row.state == 1?'已上架':scope.row.state == 2?'已下架':''}}
<!--              <p v-if="scope.row.isDel == 0" style="color: #409eff">有效</p>-->
<!--              <p v-if="scope.row.isDel == 1" style="color: red">失效</p>-->
              <p v-if="scope.row.isDefault == 1">默认选项</p>
              <p>新人状态：{{scope.row.newuserShow == 0 ? '全部' : scope.row.newuserShow == 1 ? '新用户展示' : scope.row.newuserShow == 2 ? '非新用户展示' : ''}}</p>
              <p>SVIP状态：{{scope.row.svipShow == 0 ? '全部' : scope.row.svipShow == 1 ? '已开通过SVIP会员' : scope.row.svipShow == 2 ? '未开通过SVIP会员' : ''}}</p>
              <p>用户类型：{{scope.row.isFocusUser == 0 ? '全部' :scope.row.isFocusUser == 1 ? '非关注用户' : scope.row.isFocusUser == 2 ? '关注用户' : ''}}</p>
            </template>
          </el-table-column>
          <el-table-column property="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="130">
            <template #default="scope">
              <el-space direction="vertical" alignment="flex-start">
                <el-button type="primary" size="small" @click="editSetsDialog(scope.$index,scope.row)">编辑</el-button>
                <el-button v-if="scope.row.state == 0 || scope.row.state == 2" type="success" size="small" @click="updateState(scope.$index,scope.row,1)" v-loading="scope.row.updateLoading">上架</el-button>
                <el-button v-if="scope.row.state == 1" type="danger" size="small" @click="updateState(scope.$index,scope.row,2)" v-loading="scope.row.updateLoading">下架</el-button>
                <el-button v-if="scope.row.isDefault == 1" type="danger" plain size="small" @click="updateDefault(scope.$index,scope.row,0)" v-loading="scope.row.updateDefLoading">取消默认选项</el-button>
                <el-button v-if="scope.row.isDefault == 0" type="success" plain size="small" @click="updateDefault(scope.$index,scope.row,1)" v-loading="scope.row.updateDefLoading">设为默认选项</el-button>
                <el-button v-if="scope.row.experienceState == 0" type="success" size="small" @click="updateExperience(scope.$index,scope.row,1)" v-loading="scope.row.updateExpLoading">设为体验后续费套餐</el-button>
                <el-button v-if="scope.row.experienceState == 1" type="danger" size="small" @click="updateExperience(scope.$index,scope.row,0)" v-loading="scope.row.updateExpLoading">取消体验后续费套餐</el-button>
              </el-space>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import BtnGroup from '../../components/BtnGroup'
import {
  getMarriagePageList,
  updateMarriageState,
  getMarriageListChannel,
  updateMarriageDefault,
  sendMarriageSms,
  updateMarriageExperienceState, getCommonSysParam
} from '../../api/url'
import { getFormData, postFormData } from '@/api/api'
import Dialog from "@/assets/js/dialog";
import SetsMarriageDialog from "./components/SetsMarriageDialog";

export default {
  name: "MarriageSets",
  components: { BtnGroup },
  data() {
    return {

      sexArray: [
        {label:'不限', value:-1},
        {label:'全部', value:0},
        {label:'男', value:1},
        {label:'女', value:2},
      ],
      sex: -1,

      stateArray: [
        {label:'不限', value:-1},
        {label:'待上架', value:0},
        {label:'已上架', value:1},
        {label:'已下架', value:2},
      ],
      state: -1,

      payTypeArray: [
        {label:'不限', value:-1},
        {label:'普通', value:1},
        {label:'自动续费', value:2},
      ],
      payType: -1,

      platformTypeArray: [
        {label:'不限', value:-1},
        {label:'安卓', value:1},
        {label:'ios', value:2},
        {label:'鸿蒙', value:4},
      ],
      platformType: -1,

      versionStateArray: [
        {label:'不限', value:-1},
        {label:'旧版（星级特权）', value:1},
        {label:'4.2版本及以上', value:2},
        // {label:'4.5版本及以上', value:3},
      ],
      versionState: -1,

      newuserShowArray: [
        {label:'不限', value:-1},
        {label:'全部', value:0},
        {label:'新用户', value:1},
        {label:'非新用户', value:2},
      ],
      newuserShow: -1,

      svipShowArray: [
        {label:'不限', value:-1},
        {label:'全部', value:0},
        {label:'已开通过svip', value:1},
        {label:'未开通过svip', value:2},
      ],
      svipShow: -1,

      channelArray: [
        {label:'不限', value: ''},
      ],
      channel: '',

      payModeArray: [
        {label:'不限', value:-1},
        {label:'支付宝', value:1},
        {label:'微信', value:2},
      ],
      payMode: -1,

      isSpecialPackageArray: [
        {label:'不限', value:-1},
        {label:'全部包', value:0},
        {label:'非特定包', value:2},
        {label:'特定包', value:1},
      ],
      isSpecialPackage: -1,

      isFocusUserArray: [
        {label:'不限', value:-1},
        {label:'全部', value:0},
        {label:'非关注用户', value:1},
        {label:'关注用户', value:2},
      ],
      isFocusUser: -1,


      //刷新组
      colList: [ '时间', '详细信息', '账单名称', '商品名称', '会员类型','支付方式', '原价格', '标签内容', '支付价格', 'SVIP时长', '免费试用天数', '排序', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      searchLoading: false,
      listLoading: false,

    }
  },
  methods: {
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.sex = -1;
      this.payType = -1;
      this.payMode = -1;
      this.isSpecialPackage = -1;
      this.platformType = -1;
      this.newuserShow = -1;
      this.svipShow = -1;
      this.versionState = -1;
      this.state = -1;
      this.isFocusUser = -1;
      this.channel = ''
      this.getPage(true);
    },
    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    platformChange() {
      this.channel = ''
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['sex'] = this.sex;
      param['state'] = this.state;
      param['platformType'] = this.platformType;
      param['channel'] = this.channel;
      param['newuserShow'] = this.newuserShow;
      param['svipShow'] = this.svipShow;
      param['payType'] = this.payType;
      param['versionState'] = this.versionState;
      param['payMode'] = this.payMode;
      param['isFocusUser'] = this.isFocusUser;
      param['isSpecialPackage'] = this.isSpecialPackage;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getMarriagePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch(() => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    editSetsDialog(idx, row) {
      let _title = '';
      let setsForm = {}
      if (idx > -1) {
        _title = '编辑套餐'
        setsForm = Object.assign({}, row);
      }else {
        _title = '添加套餐'
      }
      Dialog.open({
        title: _title,
        component: SetsMarriageDialog,
        data: {
          setsForm: setsForm,
          ids: idx,
          width: '600px'
        },
        confirm: (result) => {
            this.getPage()
        }
      })
    },

    updateState(idx, row, state) {
      this.$confirm('确定要将【'+ row['billName']+'】设为'+(state==1?'上架？':'下架?')).then(()=>{
        row.updateLoading = true
        let param = {}
        param['id'] = row.id
        param['state'] = state
        postFormData(updateMarriageState, param).then((data) => {
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: '设置成功',
              type: 'success'
            })
            this.pageDataList[idx].state = state
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.updateLoading = false
        })
      })
    },

    updateDefault(idx, row, state) {
      this.$confirm('确定要将【'+ row['billName']+'】'+(state==0?'取消默认？':'设为默认?')).then(()=>{
        row.updateDefLoading = true
        let param = {}
        param['id'] = row.id
        // param['sex'] = row.sex
        param['isDefault'] = state
        postFormData(updateMarriageDefault, param).then((data) => {
          let {msg, code } = data;
          if(code == 200) {
            this.$message({
              showClose: true,
              duration: 1000,
              message: '设置成功',
              type: 'success'
            })
            this.pageDataList[idx].isDefault = state
          }else{
            this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            })
          }
          row.updateDefLoading = false
        })
      })
    },

    updateExperience(idx, row, state) {
      row.updateExpLoading = true
      let param = {}
      param['id'] = row.id
      param['experienceState'] = state
      postFormData(updateMarriageExperienceState, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          this.$message({
            showClose: true,
            duration: 1000,
            message: '设置成功',
            type: 'success'
          })
          this.pageDataList[idx].experienceState = state
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        row.updateExpLoading = false
      })
    },

    // sendMarriageSms() {
    //   this.$confirm('你确定已开通数和同期服务数已设置正确?').then(()=>{
    //     getFormData(sendMarriageSms).then((data) => {
    //       let {msg, code } = data;
    //       if(code == 200) {
    //         this.$message({
    //           showClose: true,
    //           duration: 1000,
    //           message: '设置成功',
    //           type: 'success'
    //         })
    //       }else{
    //         this.$message({
    //           showClose: true,
    //           duration: 1000,
    //           message: msg,
    //           type: 'warning'
    //         })
    //       }
    //     })
    //   })
    // },

    getMarriageChannelList() {
      getFormData(getMarriageListChannel).then((data)=>{
        let {msg, code } = data;
        if(code == 200) {
          // console.log(data)
          let arr = data.data
          arr.map(item => {
            let obj = {}
            obj.label = item;
            obj.value = item;
            this.channelArray.push(obj)
          })
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getMarriageChannelList();
  }
}
</script>

<style scoped>

</style>
